export default "__VITE_ASSET__BMnP$5N2__"